import _styled from '@emotion/styled/base';

var SIZES = {
  small: 32,
  medium: 48,
  large: 80
};

var determineSize = _ref => {
  var {
    avatarSize
  } = _ref;
  return "\n  height: ".concat(SIZES[avatarSize], "px;\n  width: ").concat(SIZES[avatarSize], "px;\n");
};

var AvatarImage = _styled("img", {
  target: "emjeztb0",
  label: "AvatarImage"
})(determineSize, " background-color:", _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.COLORS.secondaryTint1;
}, ";border-radius:50%;overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVUrQiIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmNvbnN0IFNJWkVTID0ge1xuICAgIHNtYWxsOiAzMixcbiAgICBtZWRpdW06IDQ4LFxuICAgIGxhcmdlOiA4MCxcbn07XG5jb25zdCBkZXRlcm1pbmVTaXplID0gKHsgYXZhdGFyU2l6ZSwgfSkgPT4gYFxuICBoZWlnaHQ6ICR7U0laRVNbYXZhdGFyU2l6ZV19cHg7XG4gIHdpZHRoOiAke1NJWkVTW2F2YXRhclNpemVdfXB4O1xuYDtcbmNvbnN0IEF2YXRhckltYWdlID0gc3R5bGVkLmltZyBgXG4gICR7ZGV0ZXJtaW5lU2l6ZX1cbiAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5DT0xPUlMuc2Vjb25kYXJ5VGludDF9O1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIG92ZXJmbG93OiBoaWRkZW47XG5gO1xuZXhwb3J0IGRlZmF1bHQge1xuICAgIEF2YXRhckltYWdlLFxufTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlLmpzLm1hcCJdfQ== */"));

var Style = {
  AvatarImage
};

export { Style as default };
